var map = {
	"./Button.json": 2422,
	"./ConditionalRecommendedProduct.json": 1172,
	"./CustomerInfo.json": 5874,
	"./Discount.json": 4780,
	"./Divider.json": 6668,
	"./ExchangeChildLineItems.json": 3530,
	"./ExchangeChildTotals.json": 5793,
	"./ExchangeParentLineItems.json": 3107,
	"./ExchangeParentTotals.json": 6761,
	"./FeaturedProduct.json": 6722,
	"./Header.json": 1322,
	"./LineItems.json": 9431,
	"./NewDiscount.json": 122,
	"./RecommendedProducts.json": 7518,
	"./Text.json": 3953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3043;